import React, { createContext, useState, useEffect, useMemo, useContext } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import themes from "./themes"; // mapa: { scaniaLight: {...}, scaniaDark: {...}, ... }
import { AuthContext } from "./AuthContext"; // <- usa o userData.tema do usuário logado

const ThemeContext = createContext();

const DEFAULT_THEME = "scaniaLight";
const STORAGE_KEY = "currentTheme";

const ThemeContextProvider = ({ children }) => {
  const { userData } = useContext(AuthContext);

  // estado inicial: tenta localStorage; se inválido, usa default
  const [currentTheme, setCurrentTheme] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return themes[saved] ? saved : DEFAULT_THEME;
  });

  // aplica tema vindo do perfil quando disponível e válido
  useEffect(() => {
    const userTheme = userData?.tema; // <- campo no banco/tabela usuarios
    if (userTheme && themes[userTheme] && userTheme !== currentTheme) {
      setCurrentTheme(userTheme);
    }
    // se userTheme não existe, mantemos o que estiver em localStorage
  }, [userData?.tema]); // eslint-disable-line react-hooks/exhaustive-deps

  // persiste sempre que currentTheme mudar
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, currentTheme);
  }, [currentTheme]);

  const changeTheme = (themeKey) => {
    if (themes[themeKey]) {
      setCurrentTheme(themeKey);
      localStorage.setItem(STORAGE_KEY, themeKey);
    } else {
      console.warn(`Tema ${themeKey} não encontrado.`);
    }
  };

  const muiTheme = useMemo(() => createTheme(themes[currentTheme]), [currentTheme]);

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme }}>
      <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);

export default ThemeContextProvider;

/** @deprecated use useTranslatedThemeOptions() */
export const availableThemes = Object.keys(themes).map((key) => ({
  label: key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()),
  value: key,
}));
